import { dateByformat } from "../../../utils/dateHelper";
import { Button, Tag } from "antd";
import { Link } from "react-router-dom";
import React from "react";
import { currencyFormat, statusLabel } from "../../../utils/media";
import { formatString } from "../../../utils/formatString";

export const leaseCol = [
  { id: 1, headerName: "Status", field: "leaseStatus", checked: true, hide: false },
  { id: 2, headerName: "Property", field: "propertyDetails.propertyName", checked: true, hide: false },
  { id: 3, headerName: "Unit Code", field: "propertyDetails.unitCode", checked: true, hide: false },
  { id: 4, headerName: "Tenant", field: "tenantDetails.tenantNameEN", checked: true, hide: false },
  { id: 5, headerName: "Annual Rent", field: "annualRent", checked: true, hide: false },
  { id: 6, headerName: "Start Date", field: "leaseTerms.leaseStartDate", checked: true, hide: false },
  { id: 7, headerName: "End Date", field: "leaseTerms.leaseEndDate", checked: true, hide: false },
  { id: 8, headerName: "Contract Type", field: "leaseType", checked: true, hide: false },
  { id: 9, headerName: "AWB No", field: "shipmentNumber", checked: true, hide: false },

  { id: 10, headerName: "Nationality", field: "tenantDetails.nationality", checked: false, hide: true },
  { id: 11, headerName: "Email", field: "tenantDetails.email", checked: false, hide: true },
  { id: 12, headerName: "Marital Status", field: "tenantDetails.maritalStatus", checked: false, hide: true },
  { id: 13, headerName: "Signatory Name", field: "signatoryName", checked: false, hide: true },
  { id: 14, headerName: "Signatory Designation", field: "signatoryDesignation", checked: false, hide: true },
  { id: 15, headerName: "Lease Nature", field: "leaseTerms.leaseNature", checked: false, hide: true },
  { id: 16, headerName: "Lease Executive", field: "leaseManager.name", checked: false, hide: true },
  { id: 17, headerName: "External Agent", field: "externalAgent", checked: false, hide: true },
  { id: 18, headerName: "Vacating Date", field: "vacatingDate", checked: false, hide: true },
  { id: 19, headerName: "Occupants", field: "tenantDetails.numberOfOcupants", checked: false, hide: true },
  { id: 20, headerName: "Rent Free Days", field: "leaseTerms.rentFreeDays", checked: false, hide: true },
  { id: 21, headerName: "Rent Free Start", field: "leaseTerms.rentFreeStartDate", checked: false, hide: true },
  { id: 22, headerName: "Rent Free End", field: "leaseTerms.rentFreeEndDate", checked: false, hide: true },
  { id: 23, headerName: "Move-in Date", field: "leaseTerms.moveInDate", checked: false, hide: true },
  { id: 24, headerName: "Ejari Contract No", field: "ejari.contractNumber", checked: false, hide: true },
  { id: 25, headerName: "Bedrooms", field: "propertyDetails.unitSubType", checked: false, hide: true },
  { id: 26, headerName: "Usage Type", field: "propertyDetails.usagesType", checked: false, hide: true },
  { id: 27, headerName: "Built-up Area", field: "propertyDetails.areaSqft", checked: false, hide: true },
  { id: 28, headerName: "Contract Rent", field: "contractRent", checked: false, hide: true },
  { id: 29, headerName: "Unit Type", field: "unitType", checked: false, hide: true },
  { id: 30, headerName: "Owner Name", field: "ownerName", checked: false, hide: true },
  { id: 31, headerName: "Business Unit", field: "businessUnit", checked: false, hide: true },
  { id: 32, headerName: "Property Admin", field: "propertyAdmin", checked: false, hide: true },
  { id: 33, headerName: "Is AutoPay Active", field: "isAutoPayActive", checked: false, hide: true },
  { id: 34, headerName: "DEWA", field: "propertyDetails.dewa", checked: false, hide: true },
  { id: 35, headerName: "Address Line 1", field: "propertyDetails.address.addressLine1", checked: false, hide: true },
  { id: 36, headerName: "Address Line 2", field: "propertyDetails.address.addressLine2", checked: false, hide: true },
  { id: 37, headerName: "Community", field: "propertyDetails.address.community", checked: false, hide: true },
  { id: 38, headerName: "Sub Community", field: "propertyDetails.address.subCommunity", checked: false, hide: true },
  { id: 39, headerName: "Security Deposit", field: "leaseTerms.securityDeposit", checked: false, hide: true },
  { id: 40, headerName: "No. Of Installments", field: "bookingTerms.numberOfInstallments", checked: false, hide: true },
  { id: 41, headerName: "Unit Approved Rent", field: "unitApprovedRent", checked: false, hide: true },
  { id: 42, headerName: "Mobile", field: "tenantDetails.mobileNumber", checked: false, hide: true },
  {
    id: 43,
    headerName: "Direct Debit Enabled",
    field: "propertyDetails?.isDirectDebitEnable",
    checked: false,
    hide: true,
  },
  { id: 44, headerName: "Approved Rate", field: "approvedRate", checked: false, hide: true },
  { id: 443, headerName: "ID", field: "recordNumber", checked: false, hide: true },
  { id: 45, headerName: "Actions", field: "action", checked: true, hide: false },
];

function getDaysBetween(start, end) {
  const startDate: any = new Date(start);
  const endDate: any = new Date(end);
  const msInDay: any = 1000 * 60 * 60 * 24;
  return Math.ceil((endDate - startDate) / msInDay);
}

export const leaseColumn = (leaseColumns) => {
  const getModifiedStatus = (param) => {
    const leaseStatus = param?.data?.leaseStatus;
    if (leaseStatus) {
      return (
        <Tag className="tag-sm" color="success">
          {formatString(leaseStatus)}
        </Tag>
      );
    }
  };

  const viewButton = (row) => {
    return (
      <Button shape="round" size="small" type="primary">
        <Link to={`/viewbookingform/${row?.data?.leaseId}`}>View Lease</Link>
      </Button>
    );
  };

  return leaseColumns.map((col) => {
    if (col.field === "leaseStatus") {
      return { ...col, cellRendererFramework: getModifiedStatus, maxWidth: 250 };
    } else if (col.field === "leaseTerms.leaseStartDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.leaseStartDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "annualRent") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => (
          <div className="annualRent">
            {data?.leaseType?.toLowerCase() === "renewal" && data?.bookingTerms?.renewalAmount ? (
              <div style={{ position: "absolute", left: "20px" }}>
                {currencyFormat(data?.bookingTerms?.renewalAmount, "AED ")}
              </div>
            ) : (
              <div style={{ position: "absolute", left: "20px" }}>
                {currencyFormat(data?.bookingTerms?.annualBaseRent)}
              </div>
            )}
          </div>
        ),
        minWidth: 350,
      };
    } else if (col.field === "contractRent") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => (
          <div className="annualRent">
            <div style={{ position: "absolute", left: "20px" }}>{currencyFormat(data?.leaseTerms?.contractAmount)}</div>
          </div>
        ),
        minWidth: 350,
      };
    } else if (col.field === "leaseTerms.leaseEndDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.leaseEndDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "leaseTerms.moveInDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.moveInDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "leaseType") {
      return { ...col, cellRendererFramework: ({ data }) => statusLabel(data?.leaseType) };
    } else if (col.field === "action") {
      return {
        ...col,
        maxWidth: 156,
        filter: false,
        pinned: "right",
        cellRendererFramework: viewButton,
      };
    } else if (col.field === "leaseTerms.rentFreeStartDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.rentFreeStartDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "vacatingDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.vacatingDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "leaseTerms.rentFreeEndDate") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => dateByformat(data?.leaseTerms?.rentFreeEndDate, "DD-MM-YYYY"),
        minWidth: 150,
      };
    } else if (col.field === "leaseTerms.rentFreeDays") {
      return {
        ...col,
        cellRendererFramework: ({ data }) =>
          getDaysBetween(data?.leaseTerms?.rentFreeStartDate, data?.leaseTerms?.rentFreeEndDate),
      };
    } else if (col.field === "propertyDetails?.isDirectDebitEnable") {
      return {
        ...col,
        cellRendererFramework: ({ data }) => <span>{data?.propertyDetails?.isDirectDebitEnable ? "Yes" : "No"}</span>,
      };
    }
    return col;
  });
};
